var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayerPlay = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3841_1692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3879 34.2819C18.0414 34.2812 17.7011 34.1858 17.4004 34.0051C16.7232 33.602 16.3022 32.8196 16.3022 31.9702V14.7805C16.3022 13.9288 16.7232 13.1487 17.4004 12.7456C17.7083 12.5598 18.058 12.4642 18.4131 12.4689C18.7682 12.4736 19.1155 12.5784 19.4189 12.7723L33.4051 21.5663C33.6966 21.7583 33.9369 22.0249 34.1034 22.3411C34.27 22.6573 34.3574 23.0128 34.3574 23.3742C34.3574 23.7356 34.27 24.091 34.1034 24.4073C33.9369 24.7235 33.6966 24.9901 33.4051 25.1821L19.4166 33.9784C19.1062 34.1755 18.7506 34.2804 18.3879 34.2819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5633 23.209C45.5633 35.5521 35.5561 45.5583 23.2115 45.5583C10.8668 45.5583 0.859684 35.5521 0.859684 23.209C0.859684 10.8659 10.8668 0.859684 23.2115 0.859684C35.5561 0.859684 45.5633 10.8659 45.5633 23.209Z",
    stroke: "white",
    strokeWidth: 1.71937
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3841_1692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.4229,
    height: 46.4179,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayerPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/player-play.cd00900ff7d7345bdb3a04d2b9414e1d.svg";